import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLogicButton } from '../../../../utils/useForm'
import Input from '../../views/Input/Input'
import Output from '../../views/Output/Output'
import { selectGlobalSettings } from '../../../../utils/slices/settings.slice'
import { CountrySelection } from '../../views/Input/components'

const MOBILE_NAVIGATION_BTN = [
  {
    label: 'Input',
    value: 'input',
  },
  { label: 'Output', value: 'output' },
]

const MobileView = () => {
  const mobileNav = useSelector((state) => selectGlobalSettings(state).mobileNav)

  const [screen, setScreen] = useState('input')

  const Views = useMemo(
    () => ({
      input: (props) => <Input {...props} />,
      output: (props) => <Output {...props} />,
    }),
    [],
  )

  const handleNavigation = (value) => setScreen(value)

  const resetButton = useLogicButton('reset', true, () => window.location.reload())

  useEffect(() => {
    if (mobileNav) {
      document.documentElement.classList.add('-mobileNavOpen')
    } else {
      document.documentElement.classList.remove('-mobileNavOpen')
    }
  }, [mobileNav])

  useEffect(() => {
    const mediaClass = '-media-xs'
    document.documentElement.classList.remove('-media-sm', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }, [])

  return (
    <>
      <CountrySelection />

      {Object.entries(Views).map(([key, View]) => (
        <View key={key} style={{ display: key === screen ? 'block' : 'none' }} />
      ))}

      <div className="mobileSectionTabGroup">
        {MOBILE_NAVIGATION_BTN.map((item) => (
          <button
            type="button"
            key={item.value}
            value={item.value}
            className={`button mobileSectionTabButton ${item.value === screen && '-active'}`}
            onClick={() => handleNavigation(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="workspaceButtonGroup">
        <button className="button -fab resetApp" {...resetButton}>
          <span className="material-icons">refresh</span>
        </button>
      </div>
    </>
  )
}

export default MobileView
